export default {
  state: {
    errors: []
  },
  actions: {
    pushError (context, name) {
      context.commit('pushError', name)
    },
    deleteError (context, name) {
      context.commit('deleteError', name)
    }
  },
  mutations: {
    pushError (state, name) {
      let index = state.errors.indexOf(name)
      index < 0 ? state.errors.push(name) : null
    },
    deleteError (state, name) {
      let index = state.errors.indexOf(name)

      index >= 0 ? state.errors.splice(index, 1) : null

      // for (let key in state.errors) {
      //   if (key == name) {
      //     delete state.errors[key]
      //   }
      // }
    }
  }
}
